/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';

import { Field, connect } from 'formik';
import { isFinite } from 'lodash-es';

import DatePicker from '../DatePicker';
import Selection from '../Selection';
import Radio from '../Radio';
import Switch from '../Switch';
import Numeric from '../Numeric';

import 'react-datepicker/dist/react-datepicker.css';
import './MetaField.scss';
import './MdSelect.scss';

const MetaField = ({
  key,
  label,
  type,
  options,
  style,
  isEmpty,
  emptyLabel,
  dateFormat,
  datetimeFormat,
  errors,
  touched,
  field,
  digits,
  prefix,
  locale,
  ...props
}) => {
  let decimalScale = 2;

  if (Array.isArray(digits)) {
    const [_, decimal] = digits; // eslint-disable-line no-unused-vars
    decimalScale = decimal;
  } else if (isFinite(digits)) {
    decimalScale = digits;
  }

  switch (type) {
    case 'string':
    case 'char':
      return (
        <div className="meta-field string" style={{ ...style }}>
          <label htmlFor={key} className="label">
            {label}
          </label>
          <Field id={key} className="value form__field" touched={touched} errors={errors} {...props} />
          {errors[prefix] &&
            touched[prefix] &&
            errors[prefix][field.get('code')] &&
            touched[prefix][field.get('code')] && (
              <div className="input-feedback">{errors[prefix][field.get('code')]}</div>
            )}
        </div>
      );
    case 'integer':
    case 'number':
      return (
        <div className="meta-field number" style={style}>
          <label htmlFor={key} className="label">
            {label}
          </label>
          <Field
            id={key}
            className="value form__field form__field"
            touched={touched}
            errors={errors}
            type="number"
            {...props}
          />
          {errors[prefix] &&
            touched[prefix] &&
            errors[prefix][field.get('code')] &&
            touched[prefix][field.get('code')] && (
              <div className="input-feedback">{errors[prefix][field.get('code')]}</div>
            )}
        </div>
      );
    case 'numeric':
      return (
        <div className="meta-field numeric" style={style}>
          <Numeric
            id={key}
            label={label}
            touched={touched}
            errors={errors}
            decimalScale={decimalScale}
            locale={locale}
            {...props}
          />
        </div>
      );
    case 'selection':
      return (
        <div className="meta-field selection" style={style}>
          <div className="mdl-selectfield">
            <Selection
              id={key}
              label={label}
              touched={touched}
              errors={errors}
              options={options}
              isEmpty={isEmpty}
              emptyLabel={emptyLabel}
              {...props}
            />
          </div>
        </div>
      );
    case 'radio':
      return (
        <div className="meta-field selection" style={style}>
          <div className="mdl-radiofield">
            <Radio
              id={key}
              label={label}
              dateFormat={dateFormat}
              touched={touched}
              errors={errors}
              options={options}
              isEmpty={isEmpty}
              emptyLabel={emptyLabel}
              {...props}
            />
          </div>
        </div>
      );
    case 'boolean':
      return (
        <div className="meta-field boolean" style={style}>
          <div className="mdl-booleanfield">
            <Switch id={key} label={label} touched={touched} errors={errors} {...props} />
          </div>
        </div>
      );
    case 'date':
      return (
        <div className="meta-field datepicker" style={style}>
          <div className="mdl-datefield">
            <DatePicker id={key} label={label} dateFormat={dateFormat} touched={touched} errors={errors} {...props} />
          </div>
        </div>
      );
    default:
      return (
        <div className="meta-field" style={style}>
          <label htmlFor={key} className="label">
            {label}
          </label>
          <Field id={key} className="value form__field" touched={touched} errors={errors} {...props} />
          {errors[prefix] &&
            touched[prefix] &&
            errors[prefix][field.get('code')] &&
            touched[prefix][field.get('code')] && (
              <div className="input-feedback">{errors[prefix][field.get('code')]}</div>
            )}
        </div>
      );
  }
};

const option = PropTypes.shape({
  value: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
});

MetaField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.oneOf(['char', 'string', 'number', 'date', 'selection', 'boolean', 'numeric']),
  options: PropTypes.arrayOf(option),
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  isEmpty: PropTypes.bool,
  emptyLabel: PropTypes.string,
  dateFormat: PropTypes.string,
  datetimeFormat: PropTypes.string,
  prefix: PropTypes.string,
  locale: PropTypes.string,
};

MetaField.defaultProps = {
  label: undefined,
  placeholder: undefined,
  type: 'string',
  options: [],
  style: undefined,
  isEmpty: true,
  emptyLabel: undefined,
  dateFormat: 'yyyy-MM-dd',
  datetimeFormat: 'yyyy-MM-dd HH:mm:ss.fffffffzz',
  locale: 'fr',
};

export default connect(MetaField);
